export const FilterBar = ({ options, active, onChange, testPrefix = "filter" }) => (
  <section className="border-b border-[#1D1F21] sticky top-16 z-30" style={{ background: "var(--lrg-bg)" }}>
    <div className="container-custom py-3 overflow-x-auto">
      <div className="flex gap-1 min-w-max">
        {options.map((opt) => (
          <button
            key={opt.id}
            onClick={() => onChange(opt.id)}
            className={`px-4 py-2 text-[11px] font-semibold uppercase tracking-wider transition-colors ${
              active === opt.id ? "bg-[#0D6B56] text-[#090B0C]" : "text-[#F2EDE4]/30 hover:text-[#F2EDE4]"
            }`}
            data-testid={`${testPrefix}-${opt.id}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  </section>
);

export default FilterBar;
